"use strict";

var getComplementSequenceString = require("./getComplementSequenceString");
var tidyUpSequenceData = require("./tidyUpSequenceData");
// const ac = require('ve-api-check');
var getSequenceDataBetweenRange = require("./getSequenceDataBetweenRange");

// ac.throw([ac.string,ac.bool],arguments);
module.exports = function getComplementSequenceAndAnnotations(pSeqObj) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var seqObj = tidyUpSequenceData(getSequenceDataBetweenRange(pSeqObj, options.range), options);
  var newSeqObj = Object.assign({}, seqObj, {
    sequence: getComplementSequenceString(seqObj.sequence)
  });
  return tidyUpSequenceData(newSeqObj, options);
};